"use client";

import { Button } from "@/components/ui/button";
import { useStorageQuery } from "../../../../hooks/storageQueryProvider";
import { useCallback } from "react";
import { GetFoldersResponseType } from "../../../../hooks/useGetFolders";
import { t } from "@/lib/localization";

export default function SelectAll({
    folders,
}: {
    folders?: GetFoldersResponseType["data"];
}) {
    const { selectedFolders, setSelectedFolders } = useStorageQuery();

    const toggleSelectAll = useCallback(() => {
        if (!folders?.length) return;

        const someVisibleFoldersSelected = folders.some((fol1) =>
            selectedFolders.some((fol2) => fol1.id === fol2.id)
        );

        if (someVisibleFoldersSelected) {
            setSelectedFolders((prev) =>
                prev.filter((fol1) =>
                    folders.every((fol2) => fol1.id !== fol2.id)
                )
            );
        } else {
            setSelectedFolders((prev) => [...prev, ...folders]);
        }
    }, [folders, selectedFolders, setSelectedFolders]);

    return (
        <Button
            onClick={toggleSelectAll}
            className="font-normal text-sm"
            variant="outline"
            size="sm"
        >
            {t("storage.folders-grid.select-all-btn", undefined, undefined)}
        </Button>
    );
}
